import { IconModel, LocalizedValueModel } from '..';
import { DataCollectionStructureEnum } from '../enums/data-collection-type.enum';
import { DataTypeEnum } from '../enums/data-type.enum';
import { VisibilityEnum } from '../enums/visibility.enum';
import { RefProperty } from '../ref-property.model';

export class CollectionPresenterModel {
  id?: string;
  specificationVersion?: number;
  dataEntity: string;
  dataEntityType?: DataTypeEnum;
  isImplicit?: boolean;
  visibility: VisibilityEnum;
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  items?: any[];
  icon: IconModel;
  collectionType: DataCollectionStructureEnum;
  module: string;
  relatedToUser?: RefProperty;
  relatedToView?: RefProperty;
}
